module.exports = __webpack_public_path__ + "img/img_12.ce88a9c3.webp";